import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useGetReflectionTopicCountQuery } from './useGetReflectionTopicCountQuery';

export function useGetShouldShowReflectionTopics() {
  const { patientShortId } = useParams();
  const {
    data: reflectionTopicCount,
    loading: reflectionTopicCountLoading,
    getReflectionTopicCount,
  } = useGetReflectionTopicCountQuery(patientShortId ?? '');
  const isLoading = reflectionTopicCountLoading;
  const shouldShowReflectionTopics = reflectionTopicCount?.patient.reflectionTopics.totalCount > 0;

  // Memoized callback that reads the latest result on demand without
  // subscribing the consumer to re-renders. Returns boolean or undefined if
  // the query result is not yet available (in flight, errored, or skipped).
  const getShouldShowReflectionTopics = useCallback(() => {
    const count = getReflectionTopicCount();
    if (count === undefined) return undefined;
    return count > 0;
  }, [getReflectionTopicCount]);

  return {
    shouldShowReflectionTopics,
    isLoading,
    getShouldShowReflectionTopics,
  };
}
